import { HomeFilledIcon } from "@/src/Asset";
import Link from "next/link";

type BreadcrumbItem = {
  position: number;
  name: string;
  item: string;
};

export const Breadcrumb = ({
  items,
  color = "text-white",
}: {
  items: BreadcrumbItem[];
  color?: string;
}) => {
  if (items.length <= 1) return null;

  return (
    <div
      className={`flex items-center space-x-1 sm:space-x-2 py-1 sm:py-2 font-inter ${color}`}
    >
      {items.map((item, index) => (
        <div key={item.position} className="flex items-center">
          {index === 0 && (
            <Link href={item.item}>
              <HomeFilledIcon className="mr-0.5 scale-75 sm:scale-90" />
            </Link>
          )}
          {index !== 0 && index === items.length - 1 && (
            <p className="font-bold text-sm sm:text-base">{item.name}</p>
          )}
          {index !== 0 && index !== items.length - 1 && (
            <Link href={item.item} className="text-sm sm:text-base">
              {item.name}
            </Link>
          )}
          {index < items.length - 1 && (
            <span className="mx-1.5 text-xs">&gt;</span>
          )}
        </div>
      ))}
    </div>
  );
};
